import React from "react";

const Card = ({ card }) => {
  return (
    <div className="col-lg-4 col-sm-6 col-12 item">
      <div className={`card ${card.cardActivated ? "card-activated" : ""} `}>
        <div className="card-header d-flex justify-content-between align-items-center border-0">
          <h5 className="mb-0">{card.cardTitle}</h5>
          {card.cardUser && (
            <img
              src={`https://cdn.esignus.com/WLA-activity-demo/img/icon_session-on.svg`}
              alt="Session Data"
            />
          )}
        </div>
        <div className="card-body">
          {/* <h5 className="card-title">{card.cardTitle}</h5> */}
          <div className="mb-2">
            <label htmlFor="trigger" className="form-label">
              Trigger
            </label>
            <input
              type="text"
              className="form-control"
              id="trigger"
              placeholder={card.cardTrigger}
              disabled
            />
          </div>

          {/* Activity Description Section */}
          <div className="mb-0">
            <label htmlFor="activity-description" className="form-label">
              Activity description
            </label>
              <textarea className="form-control activity-description"
              id="activity-description"
              rows="2"
              placeholder={card.cardDescription}
              disabled>
              
              </textarea>  
            {/* <input
              type="text"
              className="form-control"
              id="activity-description"
              placeholder={" • " + card.cardDescription}
              disabled
            /> */}
          </div>

          {card.cardImage !== "blank.svg" ? (
            <div className="card-img">
              <img
                src={`https://cdn.esignus.com/WLA-activity-demo/img/${card.cardImage}`}
                alt={card.cardTitle}
                className="img-fluid"
              />
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default Card;
